import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import Managers from '../../components/company/managers';

function CompanyManagers({ company }) {
    const { partnerStore, authStore } = useStores();

    const { addingManager, addManagerError } = partnerStore;

    const addManager = async (form) => {
        return await partnerStore.addManager(company.company_id, form.values());
    };

    const removeManager = async (companyId, email) => {
        await partnerStore.removeManager(companyId, email);
    };

    const sendLoginInfo = async (managerEmail, companyId) => {
        await authStore.signin(
            managerEmail,
            companyId,
            null,
            null,
            '/',
            'login-info'
        );
    };

    return (
        <Managers
            company={company}
            addingManager={addingManager}
            addManagerError={addManagerError}
            addManager={addManager}
            removeManager={removeManager}
            sendLoginInfo={sendLoginInfo}
        />
    );
}

export default observer(CompanyManagers);
